export default "/images/vendor/@alquiler-argentina/aa-componentes/es/houses-animate.svg?1cc593cdc155e33215a60239ce820594";